import React, {PureComponent} from "react"
import {ApolloQueryResult} from "apollo-client"
import gql from "graphql-tag"
import {QueryProps} from "react-apollo"

import {Wallet} from "@irati/types"
import authentication from "@irati/auth"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"
import {Query} from "@irati/utils/services/apollo"

interface RewardWalletBalanceVariables {
  currency: string
  tenantId: string
  userId: string
}

interface Props extends Partial<QueryProps> {
  variables?: RewardWalletBalanceVariables
  useLoader?: boolean
  children: any
}

interface Data {
  rewardWallets: {
    results: Wallet[]
  }
  rewardWallet: Wallet
}

export type RewardWalletBalanceQueryResult = ApolloQueryResult<Data>

export interface RewardWalletBalanceData {
  data: {
    rewardWallet?: Wallet
  }
}

export const query = gql`
  query RewardWallet($tenantId: String!, $currency: String!, $userId: String!) {
    rewardWallets(tenantId: $tenantId, currency: $currency, userId: $userId) {
      results {
        availableBalance
        currency
        uuid
        ownerUuid
        walletUuid
      }
    }
  }
`

export default class RewardWalletBalanceQueryComponent extends PureComponent<Props> {
  returnFirstRewardWallet = (apolloState: ApolloState): Wallet | undefined => {
    if (!apolloState.data) {
      return undefined
    }
    if (!apolloState.data.rewardWallets) {
      return undefined
    }
    return apolloState.data.rewardWallets.results[0]
  }

  render() {
    const variables = {
      currency: authentication.defaultUserCurrency(),
      tenantId: authentication.userTenant().uuid,
      userId: authentication.user().uuid
    }

    return (
      <Query fetchPolicy="network-only" query={query} variables={variables} {...this.props}>
        {(apolloState: ApolloState) => {
          return this.props.children({
            ...apolloState,
            data: {
              ...apolloState.data,
              // return back the first wallet so we don't need repeated logic
              rewardWallet: this.returnFirstRewardWallet(apolloState)
            }
          })
        }}
      </Query>
    )
  }
}
